/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verified_DocumentsInputs */

const en_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Documents`)
};

const es_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos verificados`)
};

const fr_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents vérifiés`)
};

const de_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierte Dokumente`)
};

const ja_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証済みのドキュメント`)
};

const zh_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证的文档`)
};

const ar_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستندات موثقة`)
};

const id_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Terverifikasi`)
};

const it_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documenti Verificati`)
};

const ru_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверенные документы`)
};

const pt_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos Verificados`)
};

const ko_verified_documents = /** @type {(inputs: Verified_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검증된 문서`)
};

/**
* | output |
* | --- |
* | "Verified Documents" |
*
* @param {Verified_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verified_documents = /** @type {((inputs?: Verified_DocumentsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verified_DocumentsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verified_documents(inputs)
	if (locale === "es") return es_verified_documents(inputs)
	if (locale === "fr") return fr_verified_documents(inputs)
	if (locale === "de") return de_verified_documents(inputs)
	if (locale === "ja") return ja_verified_documents(inputs)
	if (locale === "zh") return zh_verified_documents(inputs)
	if (locale === "ar") return ar_verified_documents(inputs)
	if (locale === "id") return id_verified_documents(inputs)
	if (locale === "it") return it_verified_documents(inputs)
	if (locale === "ru") return ru_verified_documents(inputs)
	if (locale === "pt") return pt_verified_documents(inputs)
	return ko_verified_documents(inputs)
});